angular.module('capability-ng-scheduler').factory('ProgramBuilder', function ProgramBuilder(Interface) {
  var DTD = {
    id: 'key',
    nk: 'string',
    cd: 'string',
    cat_yr: 'integer',
    name: 'string',
    desc: 'string',
    credits: 'real',
    hiring_demand: 'string',
    salary_trend_max: 'string',
    salary_trend_min: 'string',
    area_of_study: 'string',
    credentials: 'string',
    rank: 'integer',
    short_credential: 'string',
    student_program_activity: 'ngObject',
    student_program_subject: 'ngObject',
    min_dev_course: 'integer',
    credential: 'string'
  };

  function ProgramDTO(data) {
    Interface.implement(DTD, data, this);
  }

  return ProgramDTO;
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/builders/suggestions/program_builder.es.js